import { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { clientesApi, crearClienteApi, editarClienteApi, clienteApi } from '../api';

const inp = { width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, background: '#f5f5f5', color: '#111', outline: 'none' };
const lbl = { display: 'block', fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 5 };

function Toggle({ label, value, onChange }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid #eee' }}>
      <span style={{ fontSize: 13, color: '#333' }}>{label}</span>
      <button type="button" onClick={() => onChange(!value)} style={{ width: 40, height: 22, borderRadius: 999, border: 'none', cursor: 'pointer', background: value ? '#1a6fbb' : '#ddd', position: 'relative', transition: 'background 0.2s' }}>
        <div style={{ width: 16, height: 16, borderRadius: '50%', background: '#fff', position: 'absolute', top: 3, transition: 'left 0.2s', left: value ? 21 : 3 }}/>
      </button>
    </div>
  );
}

const formVacio = {
  nombre: '', tipo: '', ciudad: '', sistema: '', version: '',
  contacto_nombre: '', contacto_email: '', contacto_telefono: '',
  his: false, eis: false, vuemotion: false, myvue: false, notas: '',
  conexion_ip: '', conexion_puerto: '', conexion_usuario: '', conexion_password: '',
  conexion_tipo: '', conexion_vpn: false, conexion_vpn_datos: '', conexion_notas: ''
};

export default function Clientes() {
  const [clientes, setClientes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState(formVacio);
  const [guardando, setGuardando] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [tab, setTab] = useState('general');
  const [verConexion, setVerConexion] = useState(false);

  const cargar = async () => {
    setCargando(true);
    try {
      const res = await clientesApi();
      setClientes(res.data);
    } catch(err) { console.error(err); }
    finally { setCargando(false); }
  };

  useEffect(() => { cargar(); }, []);

  const abrirEditar = async (id) => {
    try {
      const res = await clienteApi(id);
      const c = res.data;
      setForm({
        nombre: c.nombre || '', tipo: c.tipo || '', ciudad: c.ciudad || '',
        sistema: c.sistema || '', version: c.version || '',
        contacto_nombre: c.contacto_nombre || '', contacto_email: c.contacto_email || '',
        contacto_telefono: c.contacto_telefono || '',
        his: !!c.his, eis: !!c.eis, vuemotion: !!c.vuemotion, myvue: !!c.myvue,
        notas: c.notas || '',
        conexion_ip: c.conexion_ip || '', conexion_puerto: c.conexion_puerto || '',
        conexion_usuario: c.conexion_usuario || '', conexion_password: c.conexion_password || '',
        conexion_tipo: c.conexion_tipo || '', conexion_vpn: !!c.conexion_vpn,
        conexion_vpn_datos: c.conexion_vpn_datos || '', conexion_notas: c.conexion_notas || ''
      });
      setEditando(id);
      setTab('general');
      setModal(true);
    } catch(err) { console.error(err); }
  };

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      if (editando) {
        await editarClienteApi(editando, form);
      } else {
        await crearClienteApi(form);
      }
      setModal(false);
      setForm(formVacio);
      setEditando(null);
      cargar();
    } catch(err) {
      alert(err.response?.data?.error || 'Error al guardar');
    } finally { setGuardando(false); }
  };

  const tabStyle = (activo) => ({
    padding: '8px 16px', fontSize: 13, fontWeight: activo ? 600 : 400,
    color: activo ? '#1a6fbb' : '#888', background: 'none', border: 'none',
    borderBottom: activo ? '2px solid #1a6fbb' : '2px solid transparent', cursor: 'pointer'
  });

  const filtrados = clientes.filter(c =>
    c.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
    c.ciudad?.toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <Layout titulo="Clientes">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: 8 }}>
        <p style={{ fontSize: 20, fontWeight: 600, color: '#fff' }}>Clientes</p>
        <div style={{ display: 'flex', gap: 8 }}>
          <input style={{ width: 220, padding: '8px 12px', border: '1px solid #2a2a2a', borderRadius: 8, background: '#1a1a1a', color: '#fff', fontSize: 14, outline: 'none' }} placeholder="Buscar..." value={busqueda} onChange={e => setBusqueda(e.target.value)}/>
          <button className="btn btn-primary" onClick={() => { setForm(formVacio); setEditando(null); setTab('general'); setModal(true); }}>+ Nuevo cliente</button>
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {cargando ? (
          <p style={{ padding: '2rem', textAlign: 'center', color: '#555' }}>Cargando...</p>
        ) : filtrados.length === 0 ? (
          <p style={{ padding: '2rem', textAlign: 'center', color: '#555' }}>No hay clientes</p>
        ) : (
          <table>
            <thead>
              <tr><th>Nombre</th><th>Tipo</th><th>Ciudad</th><th>Sistema</th><th>Modulos</th><th>Tickets abiertos</th><th></th></tr>
            </thead>
            <tbody>
              {filtrados.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight: 500 }}>{c.nombre}</td>
                  <td style={{ color: '#aaa', fontSize: 12 }}>{c.tipo || '—'}</td>
                  <td style={{ color: '#aaa', fontSize: 12 }}>{c.ciudad || '—'}</td>
                  <td>
                    {c.sistema && <span style={{ fontSize: 11, background: '#1a1a1a', padding: '2px 7px', borderRadius: 999, color: '#aaa' }}>
                      {c.sistema === 'vuepacs_carestream' ? 'VUEPACS CS' : c.sistema === 'vuepacs_philips' ? 'VUEPACS Ph' : c.sistema}
                    </span>}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                      {c.his ? <span style={{ fontSize: 10, padding: '1px 6px', borderRadius: 999, background: '#0f2e15', color: '#4ade80' }}>HIS</span> : null}
                      {c.eis ? <span style={{ fontSize: 10, padding: '1px 6px', borderRadius: 999, background: '#0f2e15', color: '#4ade80' }}>EIS</span> : null}
                      {c.vuemotion ? <span style={{ fontSize: 10, padding: '1px 6px', borderRadius: 999, background: '#0f2e15', color: '#4ade80' }}>VM</span> : null}
                      {c.myvue ? <span style={{ fontSize: 10, padding: '1px 6px', borderRadius: 999, background: '#0f2e15', color: '#4ade80' }}>MV</span> : null}
                    </div>
                  </td>
                  <td>
                    {c.tickets_abiertos > 0
                      ? <span style={{ color: '#f87171', fontWeight: 600 }}>{c.tickets_abiertos}</span>
                      : <span style={{ color: '#444' }}>0</span>}
                  </td>
                  <td>
                    <button style={{ fontSize: 12, padding: '4px 10px', background: 'transparent', border: '1px solid #2a2a2a', color: '#aaa', borderRadius: 7, cursor: 'pointer' }} onClick={() => abrirEditar(c.id)}>
                      Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '1rem' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: '1.75rem', width: '100%', maxWidth: 580, maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <p style={{ fontWeight: 700, fontSize: 16, color: '#111' }}>{editando ? 'Editar cliente' : 'Nuevo cliente'}</p>
              <button onClick={() => setModal(false)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#aaa' }}>✕</button>
            </div>

            <div style={{ display: 'flex', borderBottom: '1px solid #eee', marginBottom: '1.25rem' }}>
              <button style={tabStyle(tab === 'general')}  onClick={() => setTab('general')}>General</button>
              <button style={tabStyle(tab === 'modulos')}  onClick={() => setTab('modulos')}>Modulos</button>
              <button style={tabStyle(tab === 'conexion')} onClick={() => setTab('conexion')}>Conexion</button>
            </div>

            <form onSubmit={guardar}>
              {tab === 'general' && (
                <>
                  <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Nombre *</label>
                    <input type="text" value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} required style={inp}/>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <div style={{ marginBottom: 14 }}>
                      <label style={lbl}>Tipo</label>
                      <input type="text" placeholder="Hospital, Clinica..." value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value })} style={inp}/>
                    </div>
                    <div style={{ marginBottom: 14 }}>
                      <label style={lbl}>Ciudad</label>
                      <input type="text" value={form.ciudad} onChange={e => setForm({ ...form, ciudad: e.target.value })} style={inp}/>
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <div style={{ marginBottom: 14 }}>
                      <label style={lbl}>Sistema</label>
                      <select value={form.sistema} onChange={e => setForm({ ...form, sistema: e.target.value })} style={inp}>
                        <option value="">Seleccionar...</option>
                        <option value="vuepacs_carestream">VUEPACS Carestream</option>
                        <option value="vuepacs_philips">VUEPACS Philips</option>
                        <option value="otro">Otro</option>
                      </select>
                    </div>
                    <div style={{ marginBottom: 14 }}>
                      <label style={lbl}>Version</label>
                      <input type="text" placeholder="ej: 4.2.0" value={form.version} onChange={e => setForm({ ...form, version: e.target.value })} style={inp}/>
                    </div>
                  </div>
                  <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Nombre del contacto</label>
                    <input type="text" value={form.contacto_nombre} onChange={e => setForm({ ...form, contacto_nombre: e.target.value })} style={inp}/>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <div style={{ marginBottom: 14 }}>
                      <label style={lbl}>Email del contacto</label>
                      <input type="email" value={form.contacto_email} onChange={e => setForm({ ...form, contacto_email: e.target.value })} style={inp}/>
                    </div>
                    <div style={{ marginBottom: 14 }}>
                      <label style={lbl}>Telefono</label>
                      <input type="text" value={form.contacto_telefono} onChange={e => setForm({ ...form, contacto_telefono: e.target.value })} style={inp}/>
                    </div>
                  </div>
                  <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Notas</label>
                    <textarea rows={3} value={form.notas} onChange={e => setForm({ ...form, notas: e.target.value })} style={inp}/>
                  </div>
                </>
              )}

              {tab === 'modulos' && (
                <div style={{ padding: '0.5rem 0' }}>
                  <Toggle label="HIS — Historia Clinica Integrada" value={form.his}       onChange={v => setForm({ ...form, his: v })}/>
                  <Toggle label="EIS — Sistema MWKS Philips"       value={form.eis}       onChange={v => setForm({ ...form, eis: v })}/>
                  <Toggle label="VueMotion"                         value={form.vuemotion} onChange={v => setForm({ ...form, vuemotion: v })}/>
                  <Toggle label="MyVue (Philips)"                   value={form.myvue}     onChange={v => setForm({ ...form, myvue: v })}/>
                </div>
              )}

              {tab === 'conexion' && (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <div style={{ marginBottom: 14 }}>
                      <label style={lbl}>IP / Host</label>
                      <input type="text" value={form.conexion_ip} onChange={e => setForm({ ...form, conexion_ip: e.target.value })} style={inp}/>
                    </div>
                    <div style={{ marginBottom: 14 }}>
                      <label style={lbl}>Puerto</label>
                      <input type="text" value={form.conexion_puerto} onChange={e => setForm({ ...form, conexion_puerto: e.target.value })} style={inp}/>
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <div style={{ marginBottom: 14 }}>
                      <label style={lbl}>Usuario</label>
                      <input type="text" value={form.conexion_usuario} onChange={e => setForm({ ...form, conexion_usuario: e.target.value })} style={inp}/>
                    </div>
                    <div style={{ marginBottom: 14 }}>
                      <label style={lbl}>Contrasena</label>
                      <div style={{ position: 'relative' }}>
                        <input type={verConexion ? 'text' : 'password'} value={form.conexion_password} onChange={e => setForm({ ...form, conexion_password: e.target.value })} style={inp}/>
                        <button type="button" onClick={() => setVerConexion(!verConexion)} style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, color: '#888' }}>
                          {verConexion ? '🙈' : '👁'}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Tipo de conexion</label>
                    <input type="text" placeholder="RDP, TeamViewer, AnyDesk..." value={form.conexion_tipo} onChange={e => setForm({ ...form, conexion_tipo: e.target.value })} style={inp}/>
                  </div>
                  <Toggle label="Requiere VPN" value={form.conexion_vpn} onChange={v => setForm({ ...form, conexion_vpn: v })}/>
                  {form.conexion_vpn && (
                    <div style={{ marginTop: 12, marginBottom: 14 }}>
                      <label style={lbl}>Datos de VPN</label>
                      <textarea rows={2} value={form.conexion_vpn_datos} onChange={e => setForm({ ...form, conexion_vpn_datos: e.target.value })} style={inp}/>
                    </div>
                  )}
                  <div style={{ marginBottom: 14, marginTop: 12 }}>
                    <label style={lbl}>Notas de conexion</label>
                    <textarea rows={3} value={form.conexion_notas} onChange={e => setForm({ ...form, conexion_notas: e.target.value })} style={inp}/>
                  </div>
                </>
              )}

              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
                <button type="button" onClick={() => setModal(false)} style={{ padding: '9px 20px', background: 'transparent', color: '#333', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, cursor: 'pointer' }}>Cancelar</button>
                <button type="submit" disabled={guardando} style={{ padding: '9px 20px', background: '#1a6fbb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                  {guardando ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}